import { useEffect, useState } from 'react'
import { Path } from 'constants/router'
import { useAppMeta } from 'components/higher-order/App/appMeta.context'
import { useLocation } from 'react-router-dom'

/**
 * Returns `true` when the user is in the signup/registration flow — including the
 * initial app load window before user/auth state has resolved, unverified-email screens,
 * and not-yet-set-up users. Used to hide workspace UI that would otherwise flash
 * incorrect state during registration.
 */
export const useIsRegistrationFlow = (): boolean => {
  const { isLoading, isUserSet, isUserVerified } = useAppMeta()
  const { pathname } = useLocation()

  // Gate on a one-shot "has ever loaded" rather than the live `isLoading`, so that
  // subsequent refetches (sagas, React Query refocus) don't re-hide the dropdown.
  const [hasEverLoaded, setHasEverLoaded] = useState(() => !isLoading)
  useEffect(() => {
    if (!isLoading) setHasEverLoaded(true)
  }, [isLoading])

  return (
    !hasEverLoaded
    || !isUserSet
    || !isUserVerified
    || pathname === Path.EMAIL_VERIFIED
    || pathname === Path.EMAIL_VERIFICATION
  )
}
